import _ from '@lodash';
import { useGrid } from '../GridProvider';
import GridComponent from '../GridComponent';

export default function DutyConversion() {
	const methods = useGrid();

	return <GridComponent {...methods} type="conversion" />;
}
